import { FC } from "react";
import styled from "styled-components";
import Content from "components/kaleido/parts/Content";

const Copyright: FC = () => {
  return (
    <Section>
      <Content>
        <Item>
          ©2003 佐藤順一・HAL・GONZO／カレイドステージ
        </Item>
      </Content>
    </Section>
  );
};
export default Copyright;

const Item = styled.p`
  text-align: center;
  color: #999;
  font-size: 0.7em;
  line-height: 1.62em;

  @media screen and (max-width: 320px) {
    font-size: 0.6em;
  }
`;

const Section = styled.section`
  margin-top: 100px;
  margin-bottom: 3px;
  width: 100%;

  @media screen and (max-width: 350px) {
    margin-top: 40px;
  }
  @media screen and (min-width: 351px) {
    margin-top: 40px;
  }
  @media screen and (min-width: 361px) {
    margin-top: 50px;
  }
  @media screen and (min-width: 371px) {
    margin-top: 60px;
  }
  @media screen and (min-width: 381px) and (max-width: 420px) {
    margin-top: 70px;
  }
`;